import React from 'react';
import { Input, Label } from 'reactstrap';
import { T } from '../traks';

const GenderSelector = (props) => {
    return (
        <div>
            <div className="mb-2"><b><T>Gender:</T></b></div>
            {['Male', 'Female', 'Other'].map((gender) => {
                return (
                <div key={`gender-${gender.toLowerCase()}`} className='radio-item pr-lg-3'>
                    <Input type="radio" className="form-check-input" id={`gender_${gender.toLowerCase()}`} name="gender" value={gender.toLowerCase()} checked={gender.toLowerCase() === props.gender} onChange={props.onChange} /> 
                    <Label className="form-check-label" for={`gender_${gender.toLowerCase()}`}>
                        <span>{gender}</span>
                    </Label>
                </div>
            )})}
        </div>
    )
}

export default GenderSelector;


// WEBPACK FOOTER //
// ./src/c/GenderInput.js